"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultPlaceTranslate = void 0;
exports.defaultPlaceTranslate = {
    neighbourhood: "Neighbourhood",
    availableListings: "Available Listings",
    follow: "Follow",
    about: "About",
    buildingInfo: "Building Information",
    followPlace: "Follow",
    unfollowPlace: "Unfollow",
    keyDetails: "Key Details",
    place: "Building",
    price: "Price",
    salePrice: "Sale Price",
    leasePrice: "Lease Price",
    salePriceAbr: "Sale",
    leasePriceAbr: "Lease",
    salePricePerSqft: "$/SF (S)",
    leasePricePerSqft: "$/SF (S)",
    pricePerSqft: "$/SF (S)",
    pricePerSqftAbr: "$/SF",
    size: "Size",
    netSize: "Net Size",
    grossSize: "Gross Size",
    update: "Date",
    date: "Date",
    photos: "Photos",
    explore: "Neighbourhood",
    filter: "Filter",
    similarProperties: "Similar Properties",
    rise: "Building Type",
    address: "Address",
    totalUnit: "Total No. Units",
    floorPerBlock: "No. Floor Per Block",
    builtYear: "Year Built",
    totalBlock: "Total Block",
    unitPerBlock: "Unit Per Block",
    unitRange: "Size Range",
    back: "Back",
    close: "Close",
    Main: "Information",
    contactAgent: "Contact",
    forSale: "For Sale",
    forRent: "For Rent",
    forAll: "For Sale and Rent",
    detailSearch: "Detail Search",
    newPlace: "New Place",
    noPhoto: "No Photo",
    gross: "G",
    grossAbr: "SF (G)",
    viewOnSearch: "View On Searches",
    bed: "Beds",
    bath: "Baths",
    addOtherPlace: "Add other place",
    addThisPlace: "Add this place",
    subjectToOffer: "Subject To Offer",
    noAvailableListingTitle: "No Available Listing",
    noAvailableListingCaption: "Unfortunately we don't have any available property for this place.",
    noAvailableListingBody: "Follow this building and we will notify you the moment we get anything.",
    topPlace: "Popular Developments",
    median: "Median",
    ppsf: "/SF (S)",
    ppsfTitle: "Avg. Price / SF",
    transactions: "Transactions",
    permonth: "/month",
    information: "information",
    net: "S",
    netAbr: "SF (S)",
    noAvailableListingTitleBuy: "No Available Listing For Sale",
    noAvailableListingTitleRent: "No Available Listing For Rent",
    sqft: "sqft",
    faq: "FAQ",
    followPopupTitle: "Stay up to date with OKAY.com",
    followPopupTitle2: "Let us help you",
    followPopupCaption: 'OKAY.com will send you the latest news, listings, and transaction information for <span class="c-bigpopup__primary">{}</span>',
    followPopupCaption2: 'There is no available listing for <span class="c-bigpopup__primary">{}</span>. Would You Like to Rent or Buy a property in <span class="c-bigpopup__primary">{}</span>?',
    followPopupCancel: "Remind me later",
    followPopupCancel2: "Remind me later",
    followPopupFollow: "Follow {}",
    followPopupFollow2: "Follow {}",
    followPopupSearchBuy: "Buy {}",
    followPopupSearchRent: "Rent {}",
    searchDistrictProperties: 'Search <span class="u-bold u-text-primary3">{}</span> Properties',
    searchMoreListingForRent: "For Rent in {}",
    searchMoreListingForSale: "For Sale in {}",
    viewMoreListingForSaleInDistrict: "More listings for Sale in {}",
    viewMoreListingForRentInDistrict: "More listings for Rent in {}",
    age: "Age",
    year: "Years",
    blocks: "Blocks",
    viewOnMap: "View On Map",
    viewDistrict: "View {} Properties",
    viewMore: "View More",
    viewLess: "View Less",
    units: "Units",
    floors: "Floors",
    unitPerFloor: "No. of Units Per Floor",
    listYourPropertyTitle: "Are you considering selling your property? <br />  Let us help!",
    listYourPropertyCta: "Find a great buyer/ tenant now!",
    listYourPropertyCaption: 'Contact Us at <span className="c-place__sell-remark-phone">+852 2102 0888</span>',
    listYourProperty: "List your property",
    buildingUnit: "Units",
    buildingBlock: "Blocks",
    buildingBuilt: "Year Built",
    include: "Include",
    exclude: "Exclude",
    transactionTitle: "Transactions",
    average: "Average",
    range: "Range",
    change: "Change",
    total: "Total",
    chart: "Chart",
    facilities: "Facilities",
};
